import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useLocation, useNavigate } from 'react-router-dom';
import { Calculator, FileText, Building2, Landmark, BarChart3, Settings } from 'lucide-react';
import Invoices from './Invoices';
import { SuppliersList } from '@/components/suppliers/SuppliersList';
import { BillsList } from '@/components/bills/BillsList';
import { BankAccountsList } from '@/components/banking/BankAccountsList';
import { BankTransactionsList } from '@/components/banking/BankTransactionsList';
import { ProfitLossReport } from '@/components/reports/ProfitLossReport';
import { XeroLiteSettings } from '@/components/settings/XeroLiteSettings';

export default function XeroLite() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Extract the current tab from the URL
  const currentPath = location.pathname;
  const currentTab = currentPath.includes('/xero-lite/bills') ? 'bills'
    : currentPath.includes('/xero-lite/suppliers') ? 'suppliers'
    : currentPath.includes('/xero-lite/banking') ? 'banking'
    : currentPath.includes('/xero-lite/reports') ? 'reports'
    : currentPath.includes('/xero-lite/settings') ? 'settings'
    : 'invoices';

  const handleTabChange = (value: string) => {
    if (value === 'invoices') {
      navigate('/xero-lite/invoices');
    } else {
      navigate(`/xero-lite/${value}`);
    }
  };

  return (
    <div className="space-y-6 p-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Xero-Lite</h1>
      </div>

      <Tabs value={currentTab} onValueChange={handleTabChange} className="space-y-4">
        <TabsList className="grid w-full grid-cols-6">
          <TabsTrigger value="invoices" className="flex items-center gap-2">
            <Calculator className="h-4 w-4" />
            Invoices
          </TabsTrigger>
          <TabsTrigger value="bills" className="flex items-center gap-2">
            <FileText className="h-4 w-4" />
            Bills
          </TabsTrigger>
          <TabsTrigger value="suppliers" className="flex items-center gap-2">
            <Building2 className="h-4 w-4" />
            Suppliers
          </TabsTrigger>
          <TabsTrigger value="banking" className="flex items-center gap-2">
            <Landmark className="h-4 w-4" />
            Banking
          </TabsTrigger>
          <TabsTrigger value="reports" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Reports
          </TabsTrigger>
          <TabsTrigger value="settings" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Settings
          </TabsTrigger>
        </TabsList>

        <TabsContent value="invoices" className="space-y-4">
          <Invoices />
        </TabsContent>
        
        <TabsContent value="bills" className="space-y-4">
          <BillsList />
        </TabsContent>
        
        <TabsContent value="suppliers" className="space-y-4">
          <SuppliersList />
        </TabsContent>
        
        <TabsContent value="banking" className="space-y-4">
          <BankAccountsList />
          <BankTransactionsList />
        </TabsContent>
        
        <TabsContent value="reports" className="space-y-4">
          <ProfitLossReport />
        </TabsContent>
        
        <TabsContent value="settings" className="space-y-4">
          <XeroLiteSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
}